import React, { useEffect, useMemo, useState } from 'react';
import { arrayOf, bool, func, node, object, oneOf, shape, string } from 'prop-types';
import classNames from 'classnames';
import { FieldCustomSelect, InlineTextButton, ValidationError } from '..';
import css from './FieldLanguagesKnown.module.css';
import { languageSelectOptions } from '../../marketplace-custom-config';
import { FormattedMessage, injectIntl } from 'react-intl';
import { findOptionsByFilterLabel, findOptionsForSelectFilter } from '../../util/search';
import config from '../../config';
import { FieldArray } from 'react-final-form-arrays';
import { FiMinus } from 'react-icons/fi';
import { BsPlusLg } from 'react-icons/bs';
import { array } from 'prop-types';
import { ReactComponent as CloseIcon } from '../../assets/svg/close.svg';
import * as validators from '../../util/validators';
import { v4 as uuidv4 } from 'uuid';
import { minimumLevelOptions, languageOption } from '../../marketplace-custom-config';

const textfield = 'textfield';
const errorTextField = 'errorTextField';

const customLabel = Object.values(languageSelectOptions).reduce((pre, curnt) => {
  pre[curnt.value] = string.isRequired;
  return pre;
}, {});

const nativeLangOptions = Object.keys(customLabel);

const defaultValueForLanguagesKnown = () => ({
  language: null,
  minimumLevel: null,
  id: uuidv4(),
});

const FieldLanguagesKnownComponent = props => {
  const {
    rootClassName,
    className,
    errorClassName,
    titleClassName,
    id,
    onChange,
    name,
    userNativeLang,
    intl,
    formApi,
    clearLanguage,
    languageOption,
    minimumLevelOptions,
    values,
    isRequired,
    from,
    languageLabel,
    minLevelLabel,
    language,
  } = props;
  const [getLanguageOptions, setGetLanguageOptions] = useState(languageOption);
  const languageKnownLabel = intl.formatMessage({
    id: 'FieldLanguagesKnown.languageKnownLabel',
  });
  const languageKnownPlaceholder = intl.formatMessage({
    id: 'FieldLanguagesKnown.languageKnownPlaceholder',
  });
  const minimumLevelLabel = intl.formatMessage({
    id: 'FieldLanguagesKnown.minimumLevelLabel',
  });
  const minimumLevelPlaceholder = intl.formatMessage({
    id: 'FieldLanguagesKnown.minimumLevelPlaceholder',
  });

  const addBtnDisabled =
    values.length > 0 ? !lastJobCategory?.category || !lastJobCategory?.subCategory : false;

  const addJobBtnLabel = intl.formatMessage({ id: 'FieldLanguagesKnown.addMoreJobBtn' });

  const addMoreKnownLanguage = (isDisabled, event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isDisabled) return;
    const {
      mutators: { push },
    } = formApi;
    push(name, defaultValueForLanguagesKnown());
  };

  const removeKnownLanguage = (event, indx) => {
    event.preventDefault();
    event.stopPropagation();
    // if (indx <= 0 && isRequired) return;
    const {
      mutators: { remove },
    } = formApi;
    remove(name, indx);
  };

  const classes = classNames(rootClassName || css.root, className, {
    [errorClassName]: !!errorClassName && hasError,
  });

  const titleClasses = classNames(css.titleWrapper, titleClassName);

  useEffect(() => {
    if (isRequired) {
      const {
        getState,
        mutators: { push },
      } = formApi;
      const { values } = getState();
      // console.log(333, values);
      const currentValue = values[name] || [];
      if (!currentValue.length) {
        push(name, defaultValueForLanguagesKnown());
      }
    }
  }, []);

  useEffect(() => {
    if (languageOption && values?.languageRequirements?.length > 0) {
      const removeLanguageOptions = languageOption?.filter(
        l => !values.languageRequirements.some(lr => lr?.language?.value === l?.value)
      );
      setGetLanguageOptions(removeLanguageOptions);
    } else if (languageOption && values?.knownLanguages?.length > 0) {
      const removeLanguageOptions = languageOption?.filter(
        l => !values.knownLanguages.some(lr => lr?.language?.value === l?.value)
      );
      setGetLanguageOptions(removeLanguageOptions);
    }
  }, [values]);

  return (
    <div className={classes} id={id}>
      {!from && !language ? (
        <div className={titleClasses}>
          <h2 className={css.heading}>
            <FormattedMessage id="FieldLanguagesKnown.spokenLanguage" />
          </h2>
        </div>
      ) : null}
      <FieldArray name={name}>
        {({ fields }) => {
          const { value } = fields;
          return fields.map((fieldName, indx) => {
            return (
              <div key={fieldName} className={css.fieldParentContainer}>
                {/* {indx === 0 && isRequired ? null : ( */}
                {/* {!isRequired || indx === 0 ? null : ( */}
                {value.length === 1 ? (
                  isRequired ? null : (
                    <button
                      type="button"
                      className={css.closeJobBtn}
                      onClick={e => removeKnownLanguage(e, indx)}
                    >
                      <FiMinus className={css.icon} />
                      <span className={css.text}>
                        {intl.formatMessage({ id: 'FieldWorkerJobCateogry.closeJobBtn' })}
                      </span>
                    </button>
                  )
                ) : (
                  <button
                    type="button"
                    className={css.closeJobBtn}
                    onClick={e => removeKnownLanguage(e, indx)}
                  >
                    <FiMinus className={css.icon} />
                    <span className={css.text}>
                      {intl.formatMessage({ id: 'FieldWorkerJobCateogry.closeJobBtn' })}
                    </span>
                  </button>
                )}
                <div className={css.fieldWrapper}>
                  <FieldCustomSelect
                    isSearchable={true}
                    id={`${fieldName}.language`}
                    name={`${fieldName}.language`}
                    options={getLanguageOptions}
                    userNativeLang={userNativeLang}
                    label={!languageLabel ? languageKnownLabel : languageLabel}
                    placeholder={languageKnownPlaceholder}
                    className={classNames(css.fieldContainer, textfield)}
                    errorClassName={errorTextField}
                    clearLanguage={clearLanguage}
                    valuesFromForm={values}

                    // validate={jobCategoryValidator}
                    // onChange={handleCateChange.bind(null, fieldName)}
                  />
                  {language ? null : (
                    <FieldCustomSelect
                      id={`${fieldName}.minimumLevel`}
                      name={`${fieldName}.minimumLevel`}
                      // className={textfield}
                      isSearchable={true}
                      errorClassName={errorTextField}
                      options={minimumLevelOptions}
                      label={!minLevelLabel ? minimumLevelLabel : minLevelLabel}
                      placeholder={minimumLevelPlaceholder}
                      userNativeLang={userNativeLang}
                      className={classNames(css.fieldContainer, textfield)}
                      valuesFromForm={values}
                    />
                  )}
                </div>
              </div>
            );
          });
        }}
      </FieldArray>
      {!language ? (
        <InlineTextButton
          type="button"
          className={css.addMoreJobBtn}
          disabled={addBtnDisabled}
          onClick={e => addMoreKnownLanguage(addBtnDisabled, e)}
        >
          <BsPlusLg className={css.icon} />
          <span className={css.text}>{addJobBtnLabel}</span>
        </InlineTextButton>
      ) : null}
    </div>
  );
};

FieldLanguagesKnownComponent.defaultProps = {
  rootClassName: null,
  className: null,
  titleClassName: null,
  errorClassName: null,
  userNativeLang: languageSelectOptions.en.value,
  values: [],
  isRequired: false,
};

FieldLanguagesKnownComponent.propTypes = {
  rootClassName: string,
  className: string,
  errorClassName: string,
  titleClassName: string,
  onChange: func,

  // Label is optional, but if it is given, an id is also required so
  // the label can reference the input in the `for` attribute
  id: string.isRequired,
  name: string.isRequired,

  formApi: object.isRequired,
  userNativeLang: oneOf(nativeLangOptions).isRequired,
  values: array.isRequired,
  isRequired: bool.isRequired,
};

const FieldLanguagesKnownComp = injectIntl(FieldLanguagesKnownComponent);

const FieldLanguagesKnown = props => {
  return (
    <FieldLanguagesKnownComp
      {...props}
      //   categoryOptions={categoryOptions}
      //   subcategoryOptions={subcategoryOptions}
      languageOption={languageOption}
      minimumLevelOptions={minimumLevelOptions}
    />
  );
};

export default FieldLanguagesKnown;

{
  /* <div className={titleClasses}>
        <h2 className={css.heading}>
          <FormattedMessage id="FieldWorkerJobCateogry.categoryHeading" />
        </h2>
        <p className={css.helperText}>
          <FormattedMessage id="FieldWorkerJobCateogry.categorySubHeading1" />
        </p>
        <h3 className={css.subHeading}>
          <FormattedMessage id="FieldWorkerJobCateogry.categorySubHeading2" />
        </h3>
      </div> */
}
// const getSubcategoryOptions = category => {
//   if (!category) return [];
//   const cateKey = typeof category === 'string' ? category : category.value ? category.value : '';
//   if (!cateKey) return [];
//   const subCateKey = `${cateKey}Subcategory`;
//   return subcategoryOptions[subCateKey] ? subcategoryOptions[subCateKey] : [];
// };

{
  /* <FieldCustomSelect
                    id={`${fieldName}.category`}
                    name={`${fieldName}.category`}
                    userNativeLang={userNativeLang}
                    options={categoryOptions}
                    label={jobCategoryLabel}
                    placeholder={jobCategoryPlaceholder}
                    className={classNames(css.fieldContainer, textfield)}
                    errorClassName={errorTextField}
                    validate={jobCategoryValidator}
                    onChange={handleCateChange.bind(null, fieldName)}
                  />
                  <FieldCustomSelect
                    id={`${fieldName}.subCategory`}
                    name={`${fieldName}.subCategory`}
                    userNativeLang={userNativeLang}
                    options={subcategoryOptions}
                    label={jobSubcategoryLabel}
                    placeholder={jobSubcategoryPlaceholder}
                    className={classNames(css.fieldContainer, textfield)}
                    errorClassName={errorTextField}
                    noOptionMsgId="FieldWorkerJobCateogry.jobSubcategoryNooptionMsg"
                    reRenderOn={subCategoryReRenderOn}
                    validate={subCategoryReRenderOn ? jobSubcategoryValidator : null}
                    onChange={handleSubcateChange.bind(null, fieldName)}
                  /> */
}

// console.log(787, fieldName, value);
// const { language } = value[indx];

// const subCategoryReRenderOn = category
//   ? typeof category === 'string'
//     ? category
//     : category.value
//   : '';
// const subcategoryOptions = getSubcategoryOptions(category);  // const handleCateChange = (fieldName, value) => {
//   const cateName = `${fieldName}.category`;
//   const subCateName = `${fieldName}.subCategory`;
//   formApi.batch(() => {
//     formApi.change(cateName, value.value);
//     formApi.change(subCateName, null);
//   });
// };
// const handleSubcateChange = (fieldName, value) => {
//   const subCateName = `${fieldName}.subCategory`;
//   formApi.change(subCateName, value.value);
// };// job category
// const jobCategoryLabel = intl.formatMessage({
//   id: isRequired
//     ? 'FieldWorkerJobCateogry.jobCategoryRequiredLabel'
//     : 'FieldWorkerJobCateogry.jobCategoryLabel',
// });
// const jobCategoryPlaceholder = intl.formatMessage({
//   id: 'FieldWorkerJobCateogry.jobCategoryPlaceholder',
// });
// const jobCategoryRequiredMessage = intl.formatMessage({
//   id: 'FieldWorkerJobCateogry.jobCategoryRequired',
// });

// const jobCategoryValidator = isRequired ? validators.required(jobCategoryRequiredMessage) : null;

// job sub category
// const jobSubcategoryLabel = intl.formatMessage({
//   id: isRequired
//     ? 'FieldWorkerJobCateogry.jobSubcategoryRequiredLabel'
//     : 'FieldWorkerJobCateogry.jobSubcategoryLabel',
// });
// const jobSubcategoryPlaceholder = intl.formatMessage({
//   id: 'FieldWorkerJobCateogry.jobSubcategoryPlaceholder',
// });

// const jobSubcategoryRequiredMessage = intl.formatMessage({
//   id: 'FieldWorkerJobCateogry.jobSubcategoryRequired',
// });

// const jobSubcategoryValidator = isRequired
//   ? validators.required(jobSubcategoryRequiredMessage)
//   : null;
// const lastJobCategory = values[values.length - 1] || defaultValueForLanguagesKnown();
